import { FILE_BASE } from "@/api";

// Generic placeholders. A new install sees neutral fallbacks until brand
// settings are loaded — never another jeweller's data. The icon assets
// are JewelFlow product chrome (safe to keep) but every name/address/phone
// field is empty so the templates render with the user's own brand the
// instant the API resolves.
export const DEFAULT_BRANDING = {
  brand_name: "",
  system_name: "",
  address_line_1: "",
  address_line_2: "",
  phone: "",
  whatsapp: "",
  email: "",
  gstin: "",
  layout_logo_url: "./jewelflow-icon.png",
  print_logo_url: "./jewelflow-logo-full.png",
};

export const resolveBrandAssetUrl = (value, fallback = "") => {
  const raw = String(value || fallback || "").trim();
  if (!raw) return "";
  if (/^(data:|https?:\/\/)/i.test(raw)) return raw;
  // Backend-served assets (uploaded logos stored as `/api/local-files/{id}`
  // or legacy `/uploads/...`) must go through FILE_BASE. Routing them via
  // PUBLIC_URL silently breaks in Electron production builds (homepage: ".",
  // file:// scheme) because `./api/local-files/...` resolves under the build
  // dir where no such file exists, the img errors, onError hides it.
  if (raw.startsWith("/api/") || raw.startsWith("/uploads/")) {
    return `${FILE_BASE}${raw}`;
  }
  if (raw.startsWith("/")) return `${process.env.PUBLIC_URL || ""}${raw}`;
  return `${process.env.PUBLIC_URL || ""}/${raw}`.replace(/([^:]\/)\/+/g, "$1");
};

export const normalizeBranding = (raw = {}) => {
  const merged = { ...DEFAULT_BRANDING, ...(raw || {}) };
  merged.full_address = [merged.address_line_1, merged.address_line_2]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join("\n");
  merged.layout_logo_src = resolveBrandAssetUrl(
    merged.layout_logo_url,
    DEFAULT_BRANDING.layout_logo_url
  );
  merged.print_logo_src = resolveBrandAssetUrl(
    merged.print_logo_url,
    DEFAULT_BRANDING.print_logo_url
  );
  return merged;
};

export const getBrandCompanyDetails = (branding) => {
  const brand = normalizeBranding(branding);
  return [
    brand.brand_name,
    brand.address_line_1,
    brand.address_line_2,
    brand.phone ? `Phone: ${brand.phone}` : "",
    brand.email ? `Email: ${brand.email}` : "",
    "Please show this coupon code during billing/purchase.",
  ]
    .filter(Boolean)
    .join("\n");
};

export const getBrandContactLine = (branding) => {
  const brand = normalizeBranding(branding);
  return [brand.phone, brand.email].filter(Boolean).join(" | ");
};
